import { render } from "./StFrancisDonorCertificate.vue?vue&type=template&id=7ece26ee"
import script from "./StFrancisDonorCertificate.vue?vue&type=script&lang=js"
export * from "./StFrancisDonorCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__